webpackJsonp([247658369337294],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(9);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _layout = __webpack_require__(10);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _para = __webpack_require__(12);
	
	var _para2 = _interopRequireDefault(_para);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _earth = __webpack_require__(357);
	
	var _earth2 = _interopRequireDefault(_earth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mission = function (_React$Component) {
	  _inherits(Mission, _React$Component);
	
	  function Mission() {
	    _classCallCheck(this, Mission);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Mission.prototype.render = function render() {
	    return _react2.default.createElement(
	      _layout2.default,
	      { key: 'main-layout', noFooter: true },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Surebro: Our Mission'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Identify & Solve Problems using Tech to make Lives Easier' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://surebro.com/mission' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Surebro: Our Mission' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Identify & Solve Problems using Tech to make Lives Easier' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png' })
	      ),
	      _react2.default.createElement(_navbar2.default, { key: 'navbar', active: 0 }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid Mission' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Mission-mission' },
	          _react2.default.createElement(_para2.default, {
	            key: 'mission-label',
	            className: 'text-left Mission-label',
	            text: 'Our Mission is to'
	          }),
	          _react2.default.createElement(_header2.default, {
	            key: 'mission-statement',
	            className: 'text-left white',
	            text: 'Identify & Solve Problems using Tech to make Lives Easier'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Mission-space-wrapper' },
	          _react2.default.createElement('img', { className: 'img Mission-space', src: _earth2.default })
	        )
	      ),
	      _react2.default.createElement('div', { style: { marginBottom: '-60px' } })
	    );
	  };
	
	  return Mission;
	}(_react2.default.Component);
	
	exports.default = Mission;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/earth.118dfde6.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mission-js-4295db6e89647cd56faf.js